/**
 * Global layout configuration for UI components
 * Centralized place for layout-related settings
 */

/**
 * ResponsiveWrapper configuration
 * Defines how form fields should behave in responsive contexts
 */
export const RESPONSIVE_WRAPPER_CONFIG = {
  /**
   * Pixel width per form field element
   * Used to calculate breakpoints: itemCount × pixelsPerItem = breakpoint width
   *
   * Change this value to adjust when form fields stack vertically
   *
   * Examples:
   * - 150px: aggressive stacking (earlier breakpoint) - fields stack sooner
   * - 200px: balanced (default, recommended) - good for most use cases
   * - 250px: relaxed stacking (later breakpoint) - fields stay together longer
   */
  pixelsPerItem: 200,
};

/**
 * Future layout configurations can be added here
 * e.g., HEADER_CONFIG, SIDEBAR_CONFIG, MODAL_CONFIG, etc.
 */
